// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TExU","title":"Header_title__3VQ9S","left":"Header_left__2BeLp","clinicName":"Header_clinicName__7ZVUY"};